import { render, staticRenderFns } from "./ship_dialog.vue?vue&type=template&id=4547eaa8&scoped=true"
import script from "./ship_dialog.vue?vue&type=script&lang=js"
export * from "./ship_dialog.vue?vue&type=script&lang=js"
import style0 from "./ship_dialog.vue?vue&type=style&index=0&id=4547eaa8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547eaa8",
  null
  
)

export default component.exports